/*
  File: src/api/characters.js
  Purpose: Characters API client with CRUD helpers (list, create, get, update, delete)
  Notes:
  - Uses shared apiClient base URL and credentials.
  - Supports JSON and multipart/form-data for image upload as data URL or File.
*/
import { apiClient } from '../auth/api';

function buildFormData(payload) {
    const fd = new FormData();
    const { series_id, name, display_name, image_url, image } = payload || {};
    if (series_id != null) fd.append('series_id', String(series_id));
    if (name != null) fd.append('name', name);
    if (display_name != null) fd.append('display_name', display_name);
    if (image_url != null) fd.append('image_url', image_url);
    if (image != null) fd.append('image', image);
    return fd;
}

export const CharactersAPI = {
    async list({ series_id, limit = 50, offset = 0 } = {}) {
        const params = {};
        if (series_id != null) params.series_id = series_id;
        if (limit != null) params.limit = limit;
        if (offset != null) params.offset = offset;
        const { data } = await apiClient.get('/characters', { params });
        return data;
    },

    async create(payload, { useMultipart = true } = {}) {
        if (useMultipart) {
            const form = buildFormData(payload);
            const { data } = await apiClient.post('/characters', form, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return data;
        }
        const { data } = await apiClient.post('/characters', payload);
        return data;
    },

    async getById(characterId) {
        const { data } = await apiClient.get(`/characters/${characterId}`);
        return data;
    },

    async update(characterId, payload, { useMultipart = true } = {}) {
        if (useMultipart) {
            const form = buildFormData(payload);
            const { data } = await apiClient.put(`/characters/${characterId}`, form, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return data;
        }
        const { data } = await apiClient.put(`/characters/${characterId}`, payload);
        return data;
    },

    async remove(characterId) {
        const { data } = await apiClient.delete(`/characters/${characterId}`);
        return data;
    }
};

export default CharactersAPI;


